import React from 'react';
import { ExtendedCheckboxProps, NCheckbox } from '@innersource-nn/novoui-react';
import LabelTooltip from './LabelTooltip';

interface NCheckboxTooltipProps extends ExtendedCheckboxProps {
    label: string;
    content: string;
}

export default function NCheckboxTooltip({
    label,
    content,
    ...rest
}: NCheckboxTooltipProps) {
    return (
        <div className="items-center flex">
            <NCheckbox className="items-center " {...rest}>
                <LabelTooltip label={label} content={content} checkbox={true} />
            </NCheckbox>
        </div>
    );
}
